import { useEffect, useRef } from 'react';
import { type Listing } from '@pkgs/api';

import { type PropertyTrackingIds } from '@/types/property.types';
import { useDidomi } from '@/providers/DidomiContextProvider';

export const useGAEventOnce = (eventName: DataLayerEventType['event'], eventMetaData?: Record<string, string>): void => {
  const isEventTriggeredRef = useRef(false);
  const didomi = useDidomi();

  useEffect(() => {
    if (isEventTriggeredRef.current) return;
    if (didomi.isReady) {
      didomi.pushGTMEvent(eventName, eventMetaData);
      isEventTriggeredRef.current = true;
    }
  }, [didomi, didomi.isReady, eventMetaData, eventName]);
};

export const useGAEvent = (eventName: DataLayerEventType['event'], hasLicencePartnerGAAccount: boolean): void => {
  const isEventTriggeredRef = useRef(false);
  const didomi = useDidomi();
  useEffect(() => {
    if (isEventTriggeredRef.current) return;
    if (hasLicencePartnerGAAccount && didomi.isReady) {
      didomi.pushGTMEvent(eventName);
      isEventTriggeredRef.current = true;
    }
  }, [didomi, didomi.isReady, eventName, hasLicencePartnerGAAccount]);
};

export const useGTMTackingIdsEvents = ({ listing, trackingIds }: { listing?: Listing; trackingIds?: PropertyTrackingIds }) => {
  const isEventTriggeredRef = useRef(false);
  const didomi = useDidomi();
  useEffect(() => {
    if (isEventTriggeredRef.current) return;
    if (trackingIds && didomi.isReady) {
      didomi.pushUrlTrackingIdsToDataLayer(trackingIds);
      isEventTriggeredRef.current = true;
    } else if (listing && didomi.isReady) {
      didomi.pushPropertyTrackingIdsToDataLayer(listing.trackingData);
      isEventTriggeredRef.current = true;
    }
  }, [listing, trackingIds, didomi.isReady, didomi]);
};
